import ReactDOM from "react-dom/client";
import App from "../src/main-component/App/App";
import "./css/flaticon.css";
import "./css/font-awesome.min.css";
import "./css/responsive.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
